var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginMobileLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 401 239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2,.cls-3{fill:none;}.cls-2,.cls-4{stroke-width:0px;}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}.cls-4{fill:#ff6c00;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 401,
    height: 239
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-237.7-138.5c0-8.6,7-15.6,15.6-15.6H330.7c5.3,0,10.3,2.2,13.7,6.2l28,32.3c3.3,3.8,5.1,8.6,5.1,13.6V41.9c.1,5.6-1.8,11-5.5,15.2l-27,31.6c-3.5,4-8.5,6.4-13.8,6.4H-222.1c-8.6,0-15.6-7-15.6-15.6v-218Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-489.8-111.1c0-11.4,9.3-20.7,20.7-20.7H266.7c7-.1,13.7,2.9,18.3,8.2l37.2,43c4.3,5,6.7,11.4,6.8,18.1l.2,191.6c0,7.4-2.6,14.6-7.5,20.2l-35.9,42c-4.6,5.4-11.3,8.5-18.4,8.5H-469c-11.4,0-20.7-9.3-20.7-20.7V-111.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 267.3,
    cy: 197.5,
    r: 17.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMobileLeft);
export default __webpack_public_path__ + "static/media/login_mobile_left.9d3989baeae872ff6bbe2fb83563604e.svg";
export { ForwardRef as ReactComponent };